export const KNOWLEDGE_CONSULTATION_METADATA_FIELDS = [
  'consultationId',
  'templateId',
  'status',
  'completedAtUtc',
  'updatedAtUtc',
  'contactId',
  'customerContactId',
  'assetId',
  'eventId',
  'scheduledAtUtc',
  'appointmentTypeId',
  'assignedEmployeeId',
  'createdAtUtc',
] as const;

export type KnowledgeConsultationMetadataField = typeof KNOWLEDGE_CONSULTATION_METADATA_FIELDS[number];

export const KNOWLEDGE_CONSULTATION_METADATA_DEFAULTS: KnowledgeConsultationMetadataField[] = [
  'consultationId',
  'templateId',
  'status',
  'completedAtUtc',
  'updatedAtUtc',
];

export const isKnowledgeConsultationMetadataField = (
  value: string,
): value is KnowledgeConsultationMetadataField =>
  (KNOWLEDGE_CONSULTATION_METADATA_FIELDS as readonly string[]).includes(value);

export const normalizeKnowledgeConsultationMetadataFields = (
  values?: readonly string[] | null,
): KnowledgeConsultationMetadataField[] => {
  if (!values || values.length === 0) {
    return [...KNOWLEDGE_CONSULTATION_METADATA_DEFAULTS];
  }

  return values.filter(isKnowledgeConsultationMetadataField);
};
